import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private initialized = false;

  constructor(private readonly swUpdate: SwUpdate, private readonly snackBar: MatSnackBar, private readonly ngZone: NgZone) {}

  init(): void {
    if (this.initialized || !this.swUpdate.isEnabled) {
      return;
    }

    this.initialized = true;

    this.swUpdate.versionUpdates
      .pipe(filter((event): event is VersionReadyEvent => event.type === 'VERSION_READY'))
      .subscribe(() => {
        this.promptUserForUpdate();
      });

    this.swUpdate.unrecoverable.subscribe(() => {
      this.ngZone.run(() => {
        const snack = this.snackBar.open('Necesitas recargar para continuar usando Ranvou.', 'Recargar');
        snack.onAction().subscribe(() => this.reloadPage());
      });
    });

    void this.swUpdate.checkForUpdate();
  }

  private promptUserForUpdate(): void {
    this.ngZone.run(() => {
      const snack = this.snackBar.open('Hay una nueva versión disponible.', 'Actualizar ahora');

      snack.onAction().subscribe(() => {
        void this.activateUpdate();
      });
    });
  }

  private async activateUpdate(): Promise<void> {
    try {
      await this.swUpdate.activateUpdate();
    } catch (error) {
      console.error('Error al activar la actualización', error);
    } finally {
      this.reloadPage();
    }
  }

  private reloadPage(): void {
    document.location.reload();
  }
}
